import {
    LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, BarChart, Bar, Brush, ComposedChart
} from 'recharts';
import { useEffect, useState } from 'react';
import { calculateSMA, calculateRSI } from './utils/indicators';
import { format } from 'date-fns';
import { apiFetch} from "apiClient";
import { apiFetch as fetch } from "apiClient";


function StockChart({ token }) {
    const [data, setData] = useState([]);
    const [timeframe, setTimeframe] = useState("1Y");

    useEffect(() => {
        const fetchData = async () => {
            try {
                const { from, to, interval } = getTimeframeRange(timeframe);

                const qs = new URLSearchParams(
                    Object.fromEntries(
                        Object.entries({ token, from, to, interval }).filter(([, v]) => v != null && v !== "")
                    )
                ).toString();

                const res = await fetch(`/api/chart-data?${qs}`);
                const json = await res.json();

                const cleanedData = (Array.isArray(json) ? json : []).map(entry => ({
                    ...entry,
                    timestamp: String(entry.time).replace("+0530", "+05:30"), // fix timezone colon
                }));

                setData(cleanedData);
            } catch (err) {
                console.error("Failed to fetch chart data:", err);
                setData([]);
            }
        };

        fetchData();
    }, [token, timeframe]);


    function getTimeframeRange(tf) {
        const now = new Date();
        let from = new Date();
        let interval = "day";

        switch (tf) {
            case "1D":
                from.setDate(now.getDate() - 1);
                interval = "5minute";
                break;
            case "1M":
                from.setMonth(now.getMonth() - 1);
                break;
            case "6M":
                from.setMonth(now.getMonth() - 6);
                break;
            case "1Y":
                from.setFullYear(now.getFullYear() - 1);
                break;
            case "5Y":
                from.setFullYear(now.getFullYear() - 5);
                break;
            case "ALL":
                from = new Date("2015-01-01");
                break;
        }

        return {
            from: from.toISOString().split("T")[0],
            to: now.toISOString().split("T")[0],
            interval
        };
    }

    const formatXAxis = (tick, timeframe) => {
        const date = new Date(tick);
        if (isNaN(date)) return '';  // Prevent crashing if invalid

        switch (timeframe) {
            case '1D': return format(date, 'HH:mm');
            case '1W': return format(date, 'dd MMM');
            case '1M': return format(date, 'dd MMM');
            case '1Y': return format(date, 'MMM yyyy');
            default: return format(date, 'yyyy');
        }
    };

    return (
        <>

            <ComposedChart width={1000} height={400} data={data}>
                <CartesianGrid stroke="#ccc" />

                <XAxis
                    dataKey="timestamp"
                    tickFormatter={(tick) => formatXAxis(tick, timeframe)}
                    minTickGap={20}
                    angle={-45}
                    interval="preserveStartEnd"
                    tick={{ fontSize: 10 }}
                />

                <YAxis yAxisId="left" domain={['auto', 'auto']} />
                <YAxis yAxisId="right" orientation="right" />

                <Tooltip />

                {/* Line for close price */}
                <Line
                    yAxisId="left"
                    type="monotone"
                    dataKey="close"
                    stroke="#8884d8"
                    dot={false}
                />

                {/* Bar for volume */}
                <Bar
                    yAxisId="right"
                    dataKey="volume"
                    fill="#82ca9d"
                    barSize={20}
                />

                <Brush dataKey="timestamp" height={30} stroke="#8884d8" />
            </ComposedChart>

            <div className="flex gap-2 mb-4">
                {["1D", "1M", "6M", "1Y", "5Y", "ALL"].map(tf => (
                    <button onClick={() => setTimeframe(tf)}>{tf}</button>
                ))}
            </div>

        </>
    );
}

export default StockChart;
